export const escalaFuncionalList = {
  a: {
    label: "1. Você tem notado alguma mudança na sua fala?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label: "Tenho notado minha fala diferente (3)",
        value: 3,
      },
      {
        label:
          "Minha fala tem mudado; frequentemente pedem para eu repetir frases ou palavras (2)",
        value: 2,
      },
      {
        label:
          "Minha fala tem mudado; às vezes preciso usar outrars formas para me comunicar (Ex.: Escrita, computador, Celular, ect...) (1)",
        value: 1,
      },
      {
        label: "Não consigo falar (0)",
        value: 0,
      },
    ],
  },
  b: {
    label:
      "2. Você tem notado alguma mudança (Aumento) na quantidade de saliva na sua boca (Independente do uso de remédio)?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label:
          "Junto pequena quantidade de saliva na boca e as vezes babo durante à noite (3)",
        value: 3,
      },
      {
        label: "Junto mais saliva na boca e às vezes babo durante o dia (2)",
        value: 2,
      },
      {
        label:
          "Junto muita saliva na boca e com certeza babo durante o dia (1)",
        value: 1,
      },
      {
        label:
          "Junto muita saliva na boca, babo muito e sempre preciso de um lenço para limpar a boca (0)",
        value: 0,
      },
    ],
  },
  c: {
    label: "3. Você tem notado alguma mudança na sua capacidade de engolir?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label:
          "Noto algumas mudanças para engolir e às vezes me engasgo com a comida (3)",
        value: 3,
      },
      {
        label:
          "Não consigo comer todos os tipos de comida e preciso que a comida seja cozida, amassada, desfiada ou passada no liquidificador (2)",
        value: 2,
      },
      {
        label:
          "Uso uma sonda para alimentação, mas ainda como algumas coisas pela boca (1)",
        value: 1,
      },
      {
        label: "Não como nada pela boca, apenas pela sonda de alimentação (0)",
        value: 0,
      },
    ],
  },
  d: {
    label: "4. Você tem notado alguma mudança na sua escrita?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label:
          "Minha escrita está mais lenta ou desajeitada, mas as pessoas conseguem ler o que eu escrevo (3)",
        value: 3,
      },
      {
        label:
          "Consigo escrever, mas as pessoas têm dificuldade de ler o que eu escrevo (2)",
        value: 2,
      },
      {
        label: "Consigo segurar a caneta, mas não consigo escrever (1)",
        value: 1,
      },
      {
        label: "Não consigo mais segurar a caneta (0)",
        value: 0,
      },
    ],
  },
  e: {
    label: "5. Manipulação de alimentos e utensílios?",
    options: [
      {
        label: "Indivíduos sem gastrostomia",
        value: 4,
      },
      {
        label: "Indivíduos com gastrostomia",
        value: 3,
      },
    ],
  },
  e1: {
    label:
      "5a. Manipulação de alimentos e utensílios (indivíduos sem gastrostomia)?",
    options: [
      {
        label: "Não tenho nenhuma dificuldade (4)",
        value: 4,
      },
      {
        label:
          "Corto alimentos e uso talheres de forma mais lenta ou desajeitada, mas não preciso da ajuda de pessoas ou objetos para conseguir comer (3)",
        value: 3,
      },
      {
        label:
          "Algumas vezes preciso de ajuda para cortar alimentos mais difíceis (2)",
        value: 2,
      },
      {
        label:
          "Minha comida precisa ser cortada por outra pessoa, mas ainda consigo me alimentar sozinho e bem devagar (1)",
        value: 1,
      },
      {
        label: "Preciso que outra pessoa coloque a comida na minha boca (0)",
        value: 0,
      },
    ],
  },
  e2: {
    label:
      "5b. Manipulação de alimentos e utensílios (indivíduos com gastrostomia)?",
    options: [
      {
        label:
          "Não tenho dificuldades e não preciso de ajuda para usar a sonda de alimentação (4)",
        value: 4,
      },
      {
        label:
          "Uso a sonda de alimentação sem ajuda, mas posso ser lento ou desajeitado (3)",
        value: 3,
      },
      {
        label:
          "Preciso de ajuda para abrir e fechar a sonda de alimentação (2)",
        value: 2,
      },
      {
        label:
          "Consigo ajudar um pouco a pessoa que coloca a dieta na minha sonda de alimentação (1)",
        value: 1,
      },
      {
        label: "Preciso de total ajuda no uso da sonda de alimentação (0)",
        value: 0,
      },
    ],
  },
  f: {
    label:
      "6. Você tem notado alguma mudança na sua capacidade de cuidar de si mesmo (se vestir, tomar banho, escovar dentes, pentear o cabelo, etc.)?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label:
          "Consigo realizar essas atividades sem ajuda, mas com muito esforço (3)",
        value: 3,
      },
      {
        label:
          "Preciso de ajuda de vez em quando ou tento me adaptar à dificuldade (me sento para me vestir, fecho os botões da camisa com a ajuda da outra mão ou de um abotoador) (2)",
        value: 2,
      },
      {
        label: "Preciso de ajuda todos os dias nessas atividades (1)",
        value: 1,
      },
      {
        label:
          "Não consigo cuidar de mim mesmo e dependo totalmente da ajuda de outra pessoa (0)",
        value: 0,
      },
    ],
  },
  g: {
    label:
      "7. Você tem notado alguma mudança na sua habilidade de se virar na cama e ajustar as roupas de cama (se cobrir com o lençol/cobertor)?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label:
          "Consigo me virar na cama e ajeitar as roupas de cama sem ajuda, mas posso ser lento ou desajeitado (3)",
        value: 3,
      },
      {
        label:
          "Consigo me virar na cama ou me cobrir com lençol/cobertor sem ajuda dos outros, mas com grande dificuldade (2)",
        value: 2,
      },
      {
        label:
          "Consigo começar a me virar na cama ou me cobrir com lençol/cobertor, mas preciso da ajuda de outra pessoa para completar a tarefa (1)",
        value: 1,
      },
      {
        label:
          "Não consigo me virar ou me cobrir com lençol/cobertor, dependo totalmente da ajuda de outra pessoa para isso (0)",
        value: 0,
      },
    ],
  },
  h: {
    label: "8. Você tem notado alguma mudança na sua capacidade de andar?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label:
          "Meu andar mudou, mas consigo andar sem ajuda de pessoas ou objetos (suporte para os pés, bengala, andador) (3)",
        value: 3,
      },
      {
        label:
          "Preciso de ajuda para andar (bengala, andador, suporte para os pés ou me segurar em alguém) (2)",
        value: 2,
      },
      {
        label:
          "Consigo mover minhas pernas ou ficar em pé, mas não consigo andar de um lugar para outro (1)",
        value: 1,
      },
      {
        label: "Não consigo andar ou mover minhas pernas (0)",
        value: 0,
      },
    ],
  },
  i: {
    label:
      "9. Você tem notado alguma mudança na sua capacidade de subir escadas?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label: "Consigo subir escadas bem devagar (3)",
        value: 3,
      },
      {
        label:
          "Consigo subir escadas, mas perco o equilíbrio e fico mais cansado (2)",
        value: 2,
      },
      {
        label:
          "Consigo subir escadas se tiver ajuda de pessoas ou objetos (corrimão ou bengala) (1)",
        value: 1,
      },
      {
        label: "Não consigo subir escadas (0)",
        value: 0,
      },
    ],
  },
  j: {
    label:
      "10. Você tem notado alguma mudança na sua respiração (respiração mais curta ou falta de ar)?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label: "Sinto falta de ar apenas quando estou andando (3)",
        value: 3,
      },
      {
        label:
          "Sinto falta de ar quando faço qualquer pequeno esforço (falar, comer, tomar banho ou vestir-se) (2)",
        value: 2,
      },
      {
        label:
          "Sinto falta de ar mesmo quando estou parado (sentado ou deitado) (1)",
        value: 1,
      },
      {
        label:
          "Sinto falta de ar o tempo todo e estou precisando da ajuda de um aparelho para respirar (0)",
        value: 0,
      },
    ],
  },
  k: {
    label:
      "11. Você tem notado alguma mudança na sua respiração quando está deitado?",
    options: [
      {
        label: "Nenhuma mudança (4)",
        value: 4,
      },
      {
        label:
          "Sinto falta de ar às vezes quando me deito de costas, mas normalmente não uso mais de dois (2) travesseiros para dormir (3)",
        value: 3,
      },
      {
        label:
          "Sinto falta de ar ao me deitar de costas e uso mais de dois travesseiros (ou equivalente) para dormir (2)",
        value: 2,
      },
      {
        label: "Só consigo dormir sentado devido à falta de ar (1)",
        value: 1,
      },
      {
        label:
          "Preciso de um suporte para respirar (aparelho de BiPAP® ou ventilação invasiva via traqueostomia) para poder dormir. Não consigo dormir sem isso (0)",
        value: 0,
      },
    ],
  },
  l: {
    label: "12. Você usa aparelho para respirar?",
    options: [
      {
        label: "Nenhuma (4)",
        value: 4,
      },
      {
        label: "Uso o aparelho BiPAP® algumas vezes no dia (3)",
        value: 3,
      },
      {
        label: "Uso o aparelho BiPAP® durante à noite (2)",
        value: 2,
      },
      {
        label:
          "Uso o aparelho BiPAP® durante noite e dia (quase 24 horas por dia) (1)",
        value: 1,
      },
      {
        label: "Respiro com ajuda de um tubo ou de uma traqueostomia (0)",
        value: 0,
      },
    ],
  },
};
